import Query from './Query';
import EntitlementMapper from './EntitlementMapper';
import Entitlement from './Entitlement';
import logInjector from './utils/logger';

/**
 * Manages a list of Entitlement instances
 */
export default class Entitlements {
  constructor(entitlementMap, resolveEntitlementFn) {
    this.info('Created');
    this.entitlements = entitlementMap || {};
    this.resolveEntitlementFn = resolveEntitlementFn;
  }

  /**
   *
   * @param {string} query - The dot notation string for which to query
   */
  async isEntitled(query) { return this.__isEntitled(Query.create(query)); }

  async __isEntitled(query) {
    if (!(query instanceof Query)) {
      throw new Error('query must be an instance of Query');
    }

    const runMatches = () => query.matches(this.entitlements, e => e.isEnabled());

    let result = runMatches();

    let updatedEntitlements = this.entitlements;
    updatedEntitlements = await this.__resolveMissingAndExpired(result);
    if (updatedEntitlements !== this.entitlements) {
      this.entitlements = updatedEntitlements;
      // Re-run the query, new updates provided
      result = runMatches();
    }

    return result.matches.length > 0;
  }

  async __resolveMissingAndExpired(result) {
    this.log('Resolving missing: ', result);
    const toResolve = [...result.missing,
      ...result.matches
        .filter(f => f.entitlement.isExpired()).map(f => f.entitlement.fullName)];
    if ((toResolve || []).length === 0) {
      return this.entitlements;
    }

    const promises = toResolve.map(async e => this.__resolveMissingOrExpired(e));

    // Should return entitelment map objects...
    // Flat?
    const resolved = await Promise.all(promises);
    let newEntitlements = { ...this.entitlements };
    resolved.forEach((entitlement) => {
      newEntitlements = EntitlementMapper.map(newEntitlements, entitlement);
    });
    return newEntitlements;
  }

  async __resolveMissingOrExpired(value) {
    this.log('resolveMissingOrExpired', value);
    if (this.resolveEntitlementFn) {
      const entitlementMissingResult = await this.resolveEntitlementFn(value);
      return (entitlementMissingResult || Entitlement.default(value));
    }
    return Entitlement.default(value);
  }
}

logInjector(Entitlements);
